import React, {Component} from 'react'
import {
  Box,
  Heading,
  VStack,
  Grid,
  GridItem,
  Text,
  Card,
  CardBody,
  HStack,
  Stat,
  StatLabel,
  StatNumber,
  Icon,
  Badge,
  SimpleGrid,
} from '@chakra-ui/react';
import { ViewIcon, ChatIcon } from '@chakra-ui/icons';
import './VertegenwoordigerWelcome.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';

class VertegenwoordigerWelcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false
    };
  }

  componentDidMount() {
    // Load data for stats
    if (this.props.loadAllSuggestions) {
      this.props.loadAllSuggestions();
    }
    if (this.props.loadSummaries) {
      this.props.loadSummaries();
    }
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    const allSuggestionsCount = this.props.state.allSuggestions?.total || 0;
    const summariesCount = this.props.state.summaries?.items?.length || 0;
    const lastUpdated = this.props.state.summaries?.lastUpdated;
    
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = {this.props.state.userVersion}
        resetSuggestionsPage = {this.props.resetSuggestionsPage}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p="10px"
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p="40px" flex="1" display="flex" justifyContent="center" alignItems="center">
          <Box maxW="1000px" w="100%">
            <VStack spacing={8} align="stretch">
              <Box textAlign="center">
                <Heading as="h1" size="xl" color="blue.600" mb={2}>
                  Welkom terug, Vertegenwoordiger {this.props.state.username}!
                </Heading>
                <Text color="gray.600" fontSize="lg">
                  Bekijk burgerinput en AI-gegenereerde analyses
                </Text>
              </Box>
              
              {/* Stats Cards */}
              <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                <Card bg="white" shadow="lg">
                  <CardBody textAlign="center">
                    <Stat>
                      <StatLabel color="gray.600">Totaal Suggesties</StatLabel>
                      <StatNumber fontSize="3xl" color="blue.600">
                        {allSuggestionsCount}
                      </StatNumber>
                    </Stat>
                  </CardBody>
                </Card>

                <Card bg="white" shadow="lg">
                  <CardBody textAlign="center">
                    <Stat>
                      <StatLabel color="gray.600">AI Overzichten</StatLabel>
                      <StatNumber fontSize="3xl" color="green.600">
                        {summariesCount}
                      </StatNumber>
                    </Stat>
                  </CardBody>
                </Card>

                <Card bg="white" shadow="lg">
                  <CardBody textAlign="center">
                    <Stat>
                      <StatLabel color="gray.600">Laatste Update</StatLabel>
                      <StatNumber fontSize="md" color="purple.600">
                        {lastUpdated ? 
                          new Date(lastUpdated).toLocaleDateString('nl-NL') : 
                          'Geen data'
                        }
                      </StatNumber>
                    </Stat>
                  </CardBody>
                </Card>
              </SimpleGrid>

              {/* Action Cards */}
              <HStack spacing={8} justify="center" mt={8}>
                <Card 
                  bg="white" 
                  shadow="md" 
                  cursor="pointer"
                  transition="transform 0.2s"
                  _hover={{ transform: 'translateY(-4px)', shadow: 'xl' }}
                  onClick={() => this.props.onRouteChange('overzicht')}
                  flex="1"
                >
                  <CardBody textAlign="center" p={8}>
                    <Icon as={ViewIcon} boxSize={10} color="green.500" mb={4} />
                    <Heading size="md" mb={2} color="gray.700">
                      AI Overzicht
                    </Heading>
                    <Text color="gray.600" mb={4}>
                      Bekijk AI-gegenereerde samenvattingen van burgerissues
                    </Text>
                    {summariesCount > 0 && (
                      <Badge colorScheme="green" variant="subtle">
                        {summariesCount} actieve thema's
                      </Badge>
                    )}
                  </CardBody>
                </Card>

                <Card 
                  bg="white" 
                  shadow="md" 
                  cursor="pointer"
                  transition="transform 0.2s"
                  _hover={{ transform: 'translateY(-4px)', shadow: 'xl' }}
                  onClick={() => this.props.onRouteChange('alleSuggesties')}
                  minW="320px"
                >
                  <CardBody textAlign="center" p={8}>
                    <Icon as={ChatIcon} boxSize={10} color="blue.500" mb={4} />
                    <Heading size="md" mb={2} color="gray.700">
                      Alle Suggesties
                    </Heading>
                    <Text color="gray.600" mb={4}>
                      Bekijk alle ingediende suggesties van inwoners
                    </Text>
                    {allSuggestionsCount > 0 && (
                      <Badge colorScheme="blue" variant="subtle">
                        {allSuggestionsCount} suggesties beschikbaar
                      </Badge>
                    )}
                  </CardBody>
                </Card>
              </HStack>

              {/* Recent Activity Summary */}
              {lastUpdated && (
                <Card bg="gray.100" shadow="sm" mt={6}>
                  <CardBody>
                    <Text textAlign="center" fontSize="sm" color="gray.600">
                      💡 <strong>Tip:</strong> Gebruik het AI Overzicht om trends te identificeren, 
                      en bekijk Alle Suggesties voor gedetailleerde burgerinput
                    </Text>
                  </CardBody>
                </Card>
              )}
            </VStack>
          </Box>
        </Box>

        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>
      
        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
        />
      </>
    )
  }
}

export default VertegenwoordigerWelcome